import type { TextareaHTMLAttributes } from "react";
import { useFieldControl } from "./Field";
import { cx } from "./utils";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** Multi-line text input. Picks up id/aria wiring from an enclosing `Field`. */
export function Textarea({ className, rows = 3, ...rest }: TextareaProps) {
  const field = useFieldControl();
  return (
    <textarea
      className={cx("xz-input", "xz-textarea", className)}
      rows={rows}
      {...field}
      {...rest}
    />
  );
}
